import { render, staticRenderFns } from "./GrupoCard.vue?vue&type=template&id=662a64cd&scoped=true&"
import script from "./GrupoCard.vue?vue&type=script&lang=js&"
export * from "./GrupoCard.vue?vue&type=script&lang=js&"
import style0 from "./GrupoCard.vue?vue&type=style&index=0&id=662a64cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662a64cd",
  null
  
)

export default component.exports